enum ENV {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  STG = 'STG',
  CERT = 'CERT',
  PROD = 'PROD',
}

export const EnvironmentService = new (class {
  private currentEnv = () => import.meta.env.VITE_BUILD_ENV as ENV;

  get isDEV() {
    return this.currentEnv() === ENV.DEV;
  }

  get isSTG() {
    return this.currentEnv() === ENV.STG;
  }

  get isCERT() {
    return this.currentEnv() === ENV.CERT;
  }

  get isPROD() {
    return this.currentEnv() === ENV.PROD;
  }

  get withLogs() {
    return [ENV.LOCAL, ENV.DEV].includes(this.currentEnv());
  }

  get environment() {
    switch (this.currentEnv()) {
      case ENV.PROD:
        return 'production';
      case ENV.CERT:
        return 'certification';
      case ENV.STG:
        return 'staging';
      default:
        return 'development';
    }
  }

  public getGoogleReCaptchaAPIKey = (): string => {
    return import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY as string;
  };

  get getUserSnapApiKey(): string {
    return import.meta.env.VITE_USERSNAP_SPACE_KEY ?? '';
  }

  get debugProjKey(): string {
    return import.meta.env.VITE_USERSNAP_DEBUG_PROJECT_KEY ?? '';
  }

  get suggestionProjKey(): string {
    return import.meta.env.VITE_USERSNAP_SUGGESTION_PROJECT_KEY ?? '';
  }
})();
